import { useMemo } from 'react'

import { useUnit } from 'effector-react'
import { useParams } from 'react-router'

import { $creatorId } from '@/models/creators.ts'
import { TikTokSoundsTrendingVideosView } from '@/modules/tiktok-research/sounds/views/TikTokSoundsTrendingVideosView.tsx'
import { AppRoutes } from '@/utils/constants'

export const TikTokSoundsTrendingVideos = () => {
  const { soundId, listId } = useParams<{ soundId: string; listId: string }>()
  const creatorId = useUnit($creatorId)

  const backPage = useMemo(() => {
    return listId && soundId
      ? {
          name: 'List',
          url: AppRoutes.TiktokResearch.Lists.Details.Index.asUrl(
            creatorId || 0,
            listId,
            soundId,
          ),
        }
      : {
          name: 'Sounds',
          url: AppRoutes.TiktokResearch.Sounds.Index.asUrl(creatorId || 0),
        }
  }, [creatorId, listId, soundId])

  if (!soundId) {
    return null
  }

  return (
    <TikTokSoundsTrendingVideosView
      soundId={soundId}
      backPage={backPage}
    />
  )
}
